export const KIND = {
    NONE       : "NONE",
    PRIMARY    : "PRIMARY",
    SECONDARY  : "SECONDARY",
    TERTIARY   : "TERTIARY",
    QUATERNARY : "QUATERNARY",
    QUINARY    : "QUINARY",
    SENARY     : "SENARY"
}

const CustomButton = ({
    type = "button",
    className = "",
    onClick,
    kind = KIND.PRIMARY,
    children,
    style
}) => {
    let defaultClass = "pl-2 pr-2 border-solid	 border-2 rounded-md outline-none"

    defaultClass += " "

    if (kind === KIND.PRIMARY){
        defaultClass +=
            "text-tertiary bg-primary--light color-tertiary border-primary active:bg-primary--dark hover:bg-primary--darknight"
    } else if (kind === KIND.SECONDARY){
        defaultClass +=
            "bg-secondary color-primary text-white active:bg-primary--dark hover:bg-primary--darknight hover:text-tertiary"
    } else if (kind === KIND.TERTIARY){
        defaultClass +=
            "text-primary border-primary hover:text-primary--dark hover:border-primary--dark active:bg-primary active:text-tertiary"
    } else if (kind === KIND.NONE){
        defaultClass += " "
    }

    const tempStyle = {
        minWidth  : "120px",
        minHeight : "40px",
        ...style
    }

    return (
        <button
            className={ `${defaultClass} ${className}` }
            style={ tempStyle }
            type={ type }
            onClick={ onClick }
        >
            { children }
        </button>
    )
}

export default CustomButton
